import "core-js/modules/es7.object.get-own-property-descriptors";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.object.keys";
import "core-js/modules/es6.function.name";
import "core-js/modules/es6.regexp.split";
import _defineProperty from "E:/workspaces/shop-app/node_modules/@babel/runtime/helpers/esm/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import CommonUtils from 'utils/CommonUtils.js';
import { mapGetters } from 'vuex';
import { GET_PLUS_SDK } from '$getters';
import config from '$config';
import api from 'api/update';
import VueMoment from 'vue-moment';
export default {
  name: 'plugin-app-update',
  props: {},
  data: function data() {
    return {
      openDialog: false,
      //新版下载
      openConfirm: false,
      //提示新版版
      openConfirmforcedUpdate: false,
      dialogProgress: 0,
      downloadedSize: '0B',
      totalSize: '0B',
      auto: true,
      versionName: '',
      versionNumber: 1010,
      app: {
        versionCode: '1.1',
        versionNumber: 2,
        // appDescribe: 'https://gz.bcebos.com/v1/dayaotex-img/update.png',
        appDescribe: '',
        downloadUrl: '',
        isForced: false
      },
      forcedUpdate: '',
      iosAppUrl: '',
      androidAppUrl: '',
      oldiosAppUrl: ''
    };
  },
  computed: _objectSpread(_objectSpread({}, mapGetters({
    plusSdk: GET_PLUS_SDK
  })), {}, {
    baseURL: function baseURL() {
      return config.baseURL;
    }
  }),
  methods: {
    findNew: function findNew() {
      var _this = this;

      var vm = this; // api.getSysDictDataByDictType({
      //   id: 7
      // }).then(res => {
      //   vm.app.appDescribe = res.data.dictValue
      //   console.log("tupian",vm.app.appDescribe)
      //强制更新与否接口=========

      console.log(vm.versionNumber);
      api.judgeVersion({
        value: vm.versionNumber
      }).then(function (res) {
        console.log('data: ' + JSON.stringify(res.data));
        vm.app.appDescribe = res.data.instructions;

        if (res.data.update === true) {
          // console.log(res.data.update + window.plus.os.name + vm.versionNumber,)
          //强制更新与否
          api.getSysDictDataByDType({
            dictType: 'forcedUpdate'
          }).then(function (res) {
            vm.forcedUpdate = res.data.dictValue;

            if (vm.forcedUpdate == "yes") {
              //强制更新
              vm.openConfirmforcedUpdate = true;
            } else {
              vm.autoupdate();
            }
          });
        } else {
          var curRoute = _this.$route.path; // 获取当前路由地址

          console.log(curRoute, "当前路由====================routes");

          if (curRoute == '/my') {
            vm.$toast('已是最新版本');
          }
        }
      }); // })
    },
    getAppVersion: function getAppVersion() {
      var vm = this;

      if (window.plus) {
        window.plus.runtime.getProperty(window.plus.runtime.appid, function (inf) {
          vm.versionName = inf.version;
          vm.versionNumber = parseInt(inf.version.split('.').join('')); // vm.versionNumber = window.plus.runtime.versionCode

          console.log('getAppVersion: ' + vm.versionName + '   ' + vm.versionNumber);
          vm.findNew();
        });
      }
    },
    autoupdate: function autoupdate() {
      this.openConfirm = true;
    },

    /**
     * 创建下载
     */
    doDownload: function doDownload() {
      var vm = this;
      this.openConfirm = false;

      if (window.plus.os.name === 'iOS' || window.plus.os.name === 'ios') {
        if (vm.forcedUpdate === "yes") {
          api.getSysDictDataByDType({
            dictType: 'iosAppUrl'
          }).then(function (res) {
            vm.iosAppUrl = res.data.dictValue;
            window.location = vm.iosAppUrl;
          });
        } else {
          api.getSysDictDataByDType({
            dictType: 'oldiosAppUrl'
          }).then(function (res) {
            vm.oldiosAppUrl = res.data.dictValue;
            window.location = vm.oldiosAppUrl;
          });
        }
      } else {
        this.openDialog = true;
        var res = '';

        if (window.plus) {
          var download = '';

          if (vm.forcedUpdate === "yes") {
            api.getSysDictDataByDType({
              dictType: 'androidAppUrl'
            }).then(function (res) {
              vm.androidAppUrl = res.data.dictValue;
              res = vm.androidAppUrl;
              download = window.plus.downloader.createDownload(res, null, null);
              download.addEventListener('statechanged', vm.onStateChanged, false);
              download.start();
            });
          } else {
            api.getSysDictDataByDType({
              dictType: 'oldandroidAppUrl'
            }).then(function (res) {
              vm.app.downloadUrl = res.data.dictValue;
              res = vm.app.downloadUrl;
              download = window.plus.downloader.createDownload(res, null, null);
              download.addEventListener('statechanged', vm.onStateChanged, false);
              download.start();
            });
          }
        }
      }
    },

    /**
     * 下载状态
     */
    onStateChanged: function onStateChanged(download, status) {
      var vm = this;

      switch (download.state) {
        case 1:
          // 开始
          // console.log('onStateChangedFileManager 文件开始下载 id: ' + download.id)
          vm.dialogProgress = 0;
          vm.downloadedSize = '0B';
          vm.totalSize = '0B';
          break;

        case 2:
          // 已连接到服务器
          // console.log('onStateChangedFileManager 已连接到服务器 id: ' + download.id)
          break;

        case 3:
          // 已接收到数据
          // console.log('onStateChangedFileManager 已接收到数据 id: ' + download.id)
          if (download.downloadedSize % 7 === 0) {
            vm.downloadedSize = CommonUtils.conver(download.downloadedSize);
            vm.totalSize = CommonUtils.conver(download.totalSize);
            var progressVal = parseInt((download.downloadedSize / download.totalSize).toFixed(2) * 100);
            vm.dialogProgress = progressVal;
          }

          break;

        case 4:
          // 下载完成
          // console.log('onStateChangedFileManager 下载完成 id: ' + download.id)
          if (status === 200) {
            this.openDialog = false;
            this.installFile(download.filename);
          }

          break;
      }
    },
    installFile: function installFile(filePath) {
      var vm = this;
      window.plus.runtime.install(filePath, null, function (widgetInfo) {
        vm.onSuccess(widgetInfo);
      }, function (err) {
        vm.onError(err);
      });
    },

    /**
     * 安装成功
     */
    onSuccess: function onSuccess(widgetInfo) {},

    /**
     * 安装失败
     */
    onError: function onError(err) {
      console.log(JSON.stringify(err));
      var vm = this;
      vm.$confirm('应用安装失败！请检查您的手机是否有空间或网络是否正常', '提示', {
        type: 'warning'
      }).then();
    }
  }
};